import {
  Box,
  Card as MuiCard,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import React from 'react';
import { colors } from '../../utils/theme';
import { CustomIcon } from '../../atoms';

export const Card = ({
  title,
  subtitle,
  content,
  cardStyles,
  icon,
}: {
  title?: string;
  subtitle?: string;
  content: React.ReactNode;
  cardStyles?: SxProps<Theme>;
  icon?: string;
}) => {
  return (
    <MuiCard
      sx={{
        py: 2.5,
        px: 2,
        background: colors.greys.BASE_WHITE,
        border: `1px solid ${colors.greys.GREY_300}`,
        display: 'flex',
        flexDirection: 'column',
        '&.MuiPaper-root': {
          boxShadow: '0px 1px 2px 0px #1018280D',
          borderRadius: 1.25,
        },
        ...cardStyles,
      }}
    >
      {icon && title && (
        <Box display="flex" flexDirection="row">
          <Typography variant="medium" fontSize={18}>
            {title}
          </Typography>
          <CustomIcon
            name={icon}
            hex="black"
            sx={{
              width: 20,
              height: 20,
              fill: colors.primarys.YELLOW,
              ml: 1,
            }}
          />
        </Box>
      )}

      {title && !icon && (
        <Typography variant="medium" fontSize={18} sx={{ mb: 0.5 }}>
          {title}
        </Typography>
      )}

      {subtitle && (
        <Typography variant="light" fontSize={14}>
          {subtitle}
        </Typography>
      )}
      {content}
    </MuiCard>
  );
};
